import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-ios-sheet',
  templateUrl: './ios-sheet.component.html',
  styleUrls: ['./ios-sheet.component.scss']
})
export class IosSheetComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
